module.exports = __webpack_public_path__ + "static/media/cbs.9c6c327a.svg";